import React, { type ComponentProps } from 'react';
import { Badge } from '@retracedgmbh/ui-components-lib';

const SIZE_CLASSES = {
  md: 'tw:min-w-[32px] tw:h-[32px]',
  lg: 'tw:min-w-[48px] tw:h-[48px] tw:text-xl',
} as const;

interface SectionIconProps {
  icon?: string;
  radius?: ComponentProps<typeof Badge>['radius'];
  type?: ComponentProps<typeof Badge>['type'];
  iconClassName?: string;
  size?: keyof typeof SIZE_CLASSES;
  children?: React.ReactNode;
}

const SectionIcon = ({ icon, radius = 'squared', type = 'primary', iconClassName, size = 'md', children }: SectionIconProps) => (
  <Badge radius={radius} type={type} className={`${SIZE_CLASSES[size]} tw:flex tw:items-center tw:justify-center`}>
    {children ?? <i className={`${icon}${iconClassName ? ` ${iconClassName}` : ''}`} />}
  </Badge>
);

export default SectionIcon;
